// Generated types for StatementSplitTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { LLMTaskReadAPI, LLMTaskWriteAPI } from '../../llm_task/types/llmtask';
import { LLMTaskReadAPISchemaObject, LLMTaskWriteAPISchemaObject } from '../../llm_task/types/llmtask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface StatementSplitTaskReadAPI extends LLMTaskReadAPI {
}

export interface StatementSplitTaskWriteAPI extends LLMTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const StatementSplitTaskReadAPISchema: z.ZodType<StatementSplitTaskReadAPI> = LLMTaskReadAPISchemaObject.extend({}).passthrough();

export const StatementSplitTaskWriteAPISchema: z.ZodType<StatementSplitTaskWriteAPI> = LLMTaskWriteAPISchemaObject.extend({}).passthrough();
